export default{
    data() {
        return {
            apis:{
                add:'sh/comment/add',//添加评论
                total:'sh/comment/total',//获取评论总数
                tree:'sh/comment/tree',//获取评论树
            },
            userKey:null,//当前登录人主键
            replay:{//回复内容对象
                content:null
            },
            curComment:null,//当前评论对象，
        }
    },
    props:{
        comments:null,
        parentName:'',//父评论的评论者姓名
    },
    mounted() {
        this.userKey = sessionStorage.getItem(this.$global.userKey);
    },
    methods: {
        showInput(comment){
            console.log(comment);
            this.curComment = comment;
        },
        save(){//添加评论
            const me = this;
            
            if(!me.userKey){
                me.$message.error('请先登录');
                return;
            }
            me.$set(me.replay, 'userKey', me.userKey);
            me.$set(me.replay, 'bizType', me.curComment.bizType);
            me.$set(me.replay, 'bizTypeName', me.curComment.bizTypeName);
            me.$set(me.replay, 'bizKey', me.curComment.bizKey);
            me.$set(me.replay, 'bizName', '回复【'+ me.curComment.bizName +'】的评论【' + me.curComment.id + '】');
            me.$set(me.replay, 'parentKey', me.curComment.id);
            me.$post({
                url: me.apis.add,
                params: me.replay
            }).then(rsp => {
                if(rsp.success){
                    me.$message.success('回复成功');
                    me.curComment = null;
                    me.$emit('saved');
                }
            })
        },
        saved(){
            this.$emit('saved');
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/base/view/interact/cmps/comment/web/child/src/child.js